// extracted by mini-css-extract-plugin
module.exports = {"no-bullets":"ServiceList_no-bullets__JVtms","columns":"ServiceList_columns__91co2","link":"ServiceList_link__CJ_Xd","search-fade-in":"ServiceList_search-fade-in__W19XL"};